import { Realization, stageMeta, conditionsDaysLeft } from './realizationConstants'

export function MediaBadges({ r, size = 'sm' }: { r: Pick<Realization, 'connection_water' | 'connection_sewer'>; size?: 'sm' | 'xs' }) {
  const cls = size === 'xs' ? 'text-[10px] px-1.5 py-0.5' : 'text-xs px-2 py-0.5'
  return (
    <span className="inline-flex items-center gap-1">
      {r.connection_water && (
        <span className={`inline-flex items-center rounded-full font-medium bg-blue-100 text-blue-800 ${cls}`}>💧 Woda</span>
      )}
      {r.connection_sewer && (
        <span className={`inline-flex items-center rounded-full font-medium bg-amber-100 text-amber-800 ${cls}`}>🚿 Kanał</span>
      )}
    </span>
  )
}

export function StageBadge({ stage }: { stage: string }) {
  const m = stageMeta(stage)
  return (
    <span
      className="inline-flex items-center rounded-full text-xs font-medium px-2 py-0.5"
      style={{ backgroundColor: m.color + '22', color: m.color }}
    >
      {m.label}
    </span>
  )
}

// Znaczek ważności warunków: badge tylko gdy wygasają (≤30 dni) lub wygasły
export function ConditionsExpiryBadge({ r }: { r: Realization }) {
  if (r.status !== 'active') return null
  const d = conditionsDaysLeft(r)
  if (d === null) return null
  if (d < 0) {
    return <span className="inline-flex items-center rounded-full text-[10px] font-semibold px-1.5 py-0.5 bg-red-600 text-white">⏰ warunki po terminie</span>
  }
  if (d <= 30) {
    return <span className="inline-flex items-center rounded-full text-[10px] font-semibold px-1.5 py-0.5 bg-amber-500 text-white">⏰ warunki: {d} dni</span>
  }
  return null
}

// Status decyzji per medium (wydane/odrzucone) — mały wskaźnik
export function ConditionsResult({ r }: { r: Realization }) {
  const chip = (label: string, val?: string | null) => {
    if (!val) return null
    const ok = val === 'issued'
    return (
      <span className={`inline-flex items-center rounded text-[10px] px-1.5 py-0.5 ${ok ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>
        {label}: {ok ? 'wydane' : 'odrzucone'}
      </span>
    )
  }
  const w = r.connection_water ? chip('Woda', r.water_conditions) : null
  const s = r.connection_sewer ? chip('Kanał', r.sewer_conditions) : null
  if (!w && !s) return null
  return <span className="inline-flex flex-wrap items-center gap-1">{w}{s}</span>
}
